import Image, { ImageAssetProps } from '../Image';
import Box, { BoxProps } from '../ui/Box';
import Txt from '../ui/Txt';
import * as style from './ImageWithCaption.css';

export type ImageWithCaptionProps = BoxProps<
  'figure',
  {
    imageProps: ImageAssetProps;
    caption?: string | null;
  }
>;

const ImageWithCaption = ({ imageProps, caption, ...props }: ImageWithCaptionProps) => {
  return (
    <Box as="figure" {...props}>
      <Image alt="" rounded {...imageProps} />
      <Txt as="figcaption" variant="small" color="black" className={style.caption}>
        {caption}
      </Txt>
    </Box>
  );
};

export default ImageWithCaption;
